import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

// Novi stili, ki jih bomo dodali ali spremenili
export const LogoImage = styled.img`
  width: 256px;
  height: auto;
  margin-bottom: 1.5rem;
  align-self: center;
  display: block;
  filter: var(--logo-filter);
`;

export const CopyrightText = styled.p`
  margin-top: 2rem;
  color: #6b7280;
  font-size: 0.85rem;
  text-align: center;
`;

export const AuthPage = styled.section`
  display: flex;
  flex-direction: column; // Omogoča, da je copyright pod kartico
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  width: 100%;
  height: 100%;
`;

export const AuthCard = styled.div`
  background: var(--bg-paper);
  border-radius: 16px;
  border: 1px solid var(--border-color);
  box-shadow: 0 20px 50px var(--shadow-color);
  width: 100%;
  max-width: 420px;
  padding: clamp(2rem, 5vw, 3rem);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.75rem;
`;

export const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem; // Povečan razmik za bolj čist videz
  width: 100%;
  align-items: stretch;
`;

export const AuthRememberLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-secondary);
  align-self: flex-start; // Poravnaj levo
  cursor: pointer;

  input {
    width: 1rem;
    height: 1rem;
    accent-color: var(--primary-color);
  }
`;

export const SecondaryLink = styled(Link)`
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  transition: text-decoration 0.2s ease;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;

const statusTextBase = css`
  margin: 0;
  font-size: 0.9rem;
  width: 100%;
  padding: 0.75rem;
  border-radius: 8px;
  text-align: center;
`;

export const ErrorText = styled.p`
  ${statusTextBase}
  color: #b91c1c;
  background-color: #fee2e2;
`;

export const SuccessText = styled.p`
  ${statusTextBase}
  color: #166534;
  background-color: #dcfce7;
`;

// --- Obstoječi stili, ki jih Register.tsx še vedno potrebuje ---
// Pustimo jih nespremenjene, da ne pokvarimo strani za registracijo

export const AuthCardContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
`;

export const AuthCardHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  align-items: center;
`;

export const AuthEyebrow = styled.p`
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: var(--primary-color);
  margin: 0;
`;

export const AuthTitle = styled.h2`
  margin: 0;
  font-size: clamp(1.9rem, 2.5vw, 2.25rem);
  font-weight: 600;
  color: var(--text-primary);
`;

export const AuthSubtitle = styled.p`
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.5;
`;

export const AuthFormHelperRow = styled.div`
  display: flex;
  font-size: 0.85rem;
  color: var(--text-secondary);
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const AuthAuxButton = styled.button`
  border: none;
  background: transparent;
  color: var(--primary-color);
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s ease;

  &:hover,
  &:focus-visible {
    color: var(--text-primary);
    text-decoration: underline;
  }
`;

export const AuthFormFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AuthCta = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
`;

export const AuthWaveRow = styled.span`
  font-size: 0.75rem;
  color: var(--text-secondary);
`;
